import React, { useState, useEffect, useCallback } from 'react';
import { useNavigate } from 'react-router-dom';
import api from '../services/api';

export default function NotificationBanner() {
  const navigate = useNavigate();
  const [count, setCount]         = useState(0);
  const [dismissed, setDismissed] = useState(false);
  const user         = JSON.parse(localStorage.getItem('user') || '{}');
  const isIntroducer = user.role === 'introducer';
  const fetchPending = useCallback(async () => {
    if (isIntroducer) return;
    try {
      const res = await api.get('/introducer-leads/pending');
      const n = res.data.count || 0;
      setCount(n);
      if (n > 0) setDismissed(false);
    } catch { /* silent */ }
  }, [isIntroducer]);
  useEffect(() => {
    if (isIntroducer) return;
    fetchPending();
    const t = setInterval(fetchPending, 60000);
    return () => clearInterval(t);
  }, [fetchPending, isIntroducer]);
  if (isIntroducer || dismissed || count === 0) return null;
  const message = count === 1 ? '1 new lead awaiting approval' : `${count} new leads awaiting approval`;
  return (
    <div style={{ display:'flex', alignItems:'center', justifyContent:'space-between', background:'#0e1b2c', color:'#fff', padding:'12px 20px', borderBottom:'3px solid #10b981', position:'sticky', top:0, zIndex:100, flexWrap:'wrap', gap:10 }}>
      <span>🔔 <strong>{message}</strong></span>
      <div style={{ display:'flex', gap:8 }}>
        <button onClick={() => { setDismissed(true); navigate('/leads'); }}
          style={{ background:'#10b981', color:'#fff', border:'none', borderRadius:6, padding:'7px 16px', fontWeight:600, cursor:'pointer' }}>
          Review now
        </button>
        <button onClick={() => setDismissed(true)}
          style={{ background:'transparent', border:'1px solid rgba(255,255,255,0.3)', color:'rgba(255,255,255,0.7)', borderRadius:6, padding:'6px 10px', cursor:'pointer' }}>
          ✕
        </button>
      </div>
    </div>
  );
}
